import { Base64Decode } from "./Base64Decode"

/**
 * Decodes a URL-safe Base64 string to a Uint8Array.
 * Converts URL-safe characters (-_) back to standard Base64 (+/) and adds padding.
 *
 * @param data - URL-safe Base64 encoded string (no padding)
 * @returns Decoded bytes as Uint8Array
 *
 * @example
 * ```ts
 * import { Base64URLDecode } from "@pdfking/tfunc"
 *
 * const bytes = Base64URLDecode("SGVsbG8gV29ybGQ") // no padding, URL-safe
 * new TextDecoder().decode(bytes) // "Hello World"
 * ```
 */
export const Base64URLDecode = (data: string): Uint8Array => {
  // Replace URL-safe characters back to standard base64
  let base64 = data.replace(/-/g, "+").replace(/_/g, "/")

  // Add padding if necessary
  const padding = base64.length % 4
  if (padding === 2) {
    base64 += "=="
  } else if (padding === 3) {
    base64 += "="
  }

  return Base64Decode(base64)
}
